<template>
    <div class="flex-level">
        <div class="ellipsis search-result-item gray-100"><span>{{ data.name }}</span></div>
        <div class="ellipsis search-result-item ml-2 gray-60"><span>{{ data.company }}</span></div>
        <div class="ellipsis search-result-item ml-2 gray-60"><span>{{ data.position }}</span></div>
        <div v-if="data.link" class="flex-right"><i class="icon-chevron-right gray-60"></i></div>
    </div>
</template>

<script>

export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
}
</script>

